<template>
    <Modal>
        <a class="flex items-center rounded text-[20px]">
            <ion-icon name="cog"></ion-icon>
        </a>
        <template #body>
            <div
                class="
                    text-sm
                    font-medium
                    text-center text-gray-500
                    border-b border-gray-200
                    absolute
                    w-full
                    left-0
                    top-0
                "
            >
                <ul class="flex flex-wrap -mb-px">
                    <li
                        class="me-2"
                        v-for="tab in tabs"
                        :key="tab"
                        @click="state.currentTab = tab"
                    >
                        <a
                            class="
                                inline-block
                                p-4
                                border-b-2 border-transparent
                                rounded-t-lg
                                hover:text-gray-600 hover:border-gray-300
                                cursor-pointer
                            "
                            :style="`${
                                tab === state.currentTab &&
                                'color: rgb(63, 131, 248);border-color: rgb(63, 131, 248);'
                            }`"
                            >{{ tab }}</a
                        >
                    </li>
                </ul>
            </div>
            <FormationSetting
                :team-id="teamId"
                v-show="state.currentTab === 'Formation'"
            ></FormationSetting>
            <PackageSetting
                :team-id="teamId"
                v-show="state.currentTab === 'Package'"
            ></PackageSetting>
        </template>
    </Modal>
</template>

<script setup>
import Modal from "./Modal";
import { reactive, onMounted, defineProps } from "vue";

const props = defineProps({
    teamId: {
        type: String,
    },
});

const state = reactive({
    currentTab: "Formation",
});

const tabs = ["Formation", "Package"];
</script>
